export default "__VITE_ASSET__DGqGe60$__"